(function () {
  if (window.themeProductCardQuickAdd) {
    return;
  }
  window.themeProductCardQuickAdd = true;

  function setPickerState(form, expanded) {
    if (!form) {
      return;
    }
    const wrap = form.closest('.product-card__quick-add');
    const toggleButton = form.querySelector('[data-quick-add-toggle]');
    const optionsPanel = form.querySelector('[data-quick-add-options]');
    if (!wrap || !toggleButton || !optionsPanel) {
      return;
    }
    wrap.classList.toggle('is-open', expanded);
    toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    optionsPanel.hidden = !expanded;
  }

  function closePickers(exceptForm) {
    document.querySelectorAll('[data-quick-add-form]').forEach(function (form) {
      if (exceptForm && form === exceptForm) {
        return;
      }
      setPickerState(form, false);
    });
  }

  function publishAddRequest(form) {
    if (!form || !window.themePubsub || typeof window.themePubsub.publish !== 'function') {
      return;
    }
    const variantInput = form.querySelector('[data-quick-add-variant-input]');
    const variantId = variantInput ? variantInput.value : '';
    if (!variantId) {
      return;
    }
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    window.themePubsub.publish('cart:add-request', { formData: formData });
  }

  document.addEventListener('click', function (event) {
    const variantButton = event.target.closest('[data-quick-add-variant]');
    if (variantButton) {
      event.preventDefault();
      if (variantButton.disabled) {
        return;
      }
      const form = variantButton.closest('[data-quick-add-form]');
      const variantInput = form ? form.querySelector('[data-quick-add-variant-input]') : null;
      if (!form || !variantInput) {
        return;
      }
      variantInput.value = variantButton.dataset.quickAddVariant || '';
      publishAddRequest(form);
      setPickerState(form, false);
      return;
    }

    const submitButton = event.target.closest('[data-quick-add-submit]');
    if (submitButton) {
      event.preventDefault();
      const form = submitButton.closest('[data-quick-add-form]');
      publishAddRequest(form);
      closePickers();
      return;
    }

    const toggleButton = event.target.closest('[data-quick-add-toggle]');
    if (toggleButton) {
      event.preventDefault();
      const form = toggleButton.closest('[data-quick-add-form]');
      const optionsPanel = form ? form.querySelector('[data-quick-add-options]') : null;
      if (!form || !optionsPanel) {
        return;
      }
      const nextExpanded = optionsPanel.hidden;
      closePickers(form);
      setPickerState(form, nextExpanded);
      return;
    }

    if (!event.target.closest('[data-quick-add-form]')) {
      closePickers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePickers();
    }
  });
})();
